"use strict";

import { addFilter } from '@wordpress/hooks';

const aicontentControls = wp.compose.createHigherOrderComponent((BlockEdit) => {
	return (props) => {
		const { Fragment,useState } = wp.element;
		const { PanelBody,ToggleControl,SelectControl,Button } = wp.components;
		const { InspectorControls } = wp.blockEditor;
		const { attributes, setAttributes, isSelected } = props;
		const [ isRunning, setIsRunning ] = useState( false );
		const allowedTags = ['core/quote','core/heading','core/paragraph','core/preformatted'
			,'core/pullquote','core/verse']

		var promptOptions = []
	  	for (const key in aicontent.prompts) {
		    promptOptions.push({label:aicontent.prompts[key], value:key})
		}
		const [ aiTask, setAiTask ] = useState(promptOptions[0].value);
		const prepareContent = (content) =>{
			let selectedBlockClientIds = wp.data.select('core/block-editor').getSelectedBlockClientId();
			let indexToInsertAt = wp.data.select('core/block-editor').getBlockIndex(selectedBlockClientIds) + 1;
			let autoCompleteBlock = wp.blocks.createBlock('core/paragraph', {content: content});
			wp.data.dispatch('core/block-editor').insertBlock(
            autoCompleteBlock,
            indexToInsertAt
        );

		}	

		const handleClick = (event) => {
		  	
		  	setIsRunning(true);
		  	const nonce = aicontent.nonce
		  	const rest_nonce = aicontent.rest_nonce
		  	
			let text = '';
			if ('content' in attributes) {
				text = attributes.content;
			} else if ('citation' in attributes) {
				text = attributes.citation;
			} else if ('value' in attributes) {
				text = attributes.value;
			} else if ('values' in attributes) {
				text = attributes.values;
			} else if ('text' in attributes) {
				text = attributes.text;
			}

		  const response = fetch(aicontent.siteUrl + '/wp-json/aicontent/v1/text', {
	        method: 'POST',
	        headers: {
	            'Content-Type': 'application/json',
	            'X-WP-Nonce': rest_nonce,
	        },
	        body: JSON.stringify({
	            text: text,
	            type: aiTask,
	        })
		    }).then(function(response) {
			    // The response is a Response instance.
			    // You parse the data into a useable format using `.json()`
			    return response.json();
			  }).then(function(data) {
			    // `data` is the parsed version of the JSON returned from the above endpoint.
				if(typeof data.message != undefined && typeof data.message != undefined){
					var newContent = data.message
					prepareContent(newContent);
				}
				setIsRunning(false);
			});

	  	}
	  	
	  	

	  	return (
			<Fragment>
				<BlockEdit {...props} />
				{isSelected  && allowedTags.includes(props.name) &&
					<InspectorControls>
						<PanelBody title={wp.i18n.__("AI Content", 'ai-content')}>
						<SelectControl
			            label={wp.i18n.__("Choose AI Task", 'ai-content')}
			            value={ attributes.aiTask }
			            options={ promptOptions }
			            onChange={ ( newAiTask ) => {setAiTask(newAiTask)} }
			        	/>
			        	<Button isBusy={isRunning} disabled={isRunning} variant="primary" onClick={handleClick}>{wp.i18n.__('Submit', 'ai-content')}</Button>
				
					</PanelBody>	
					</InspectorControls>
				}
			</Fragment>
		);
	};
}, 'aicontentControls');
 
addFilter(
	'editor.BlockEdit',
	'aicontent/wp-aikit-controls',
	aicontentControls
);